import { useState, useEffect } from 'react';

import CustomerService from '../../services/customerService';
import useUser from '../user/useUser';
import { countriesEnum, DocumentType, GetDocumentTypeByCountry } from '../../models/EnumEntity';

const CACHE_KEY = 'x-generic-customer';

export const clearGenericCustomerCache = () => {
    Object.keys(localStorage)
        .filter(k => k.startsWith(CACHE_KEY))
        .forEach(k => localStorage.removeItem(k));
};

const useGenericCustomer = () => {
    const { branch } = useUser();
    const [genericCustomer, setGenericCustomer] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!branch?.country) return;

        const cacheKey = `${CACHE_KEY}-${branch.country}`;
        const cached = localStorage.getItem(cacheKey);

        if (cached) {
            setGenericCustomer(JSON.parse(cached));
            return;
        }

        const documentType = branch.country === countriesEnum.AR ? DocumentType.DNI : DocumentType.OTHER;
        setLoading(true);
        CustomerService
            .Search({ documentType, documentNumber: '11111111', operationCountry: branch.country })
            .then(res => {
                const docTypes = GetDocumentTypeByCountry(branch.country);
                const result = res.values.filter(d => docTypes.find(i => i.value === d.documentType));
                if (result.length > 0) {
                    localStorage.setItem(cacheKey, JSON.stringify(result[0]));
                    setGenericCustomer(result[0]);
                }
            })
            .finally(() => setLoading(false));
    }, [branch?.country]);

    return { genericCustomer, loading };
};

export default useGenericCustomer;
